import React from 'react'
import { Navbar, Nav, Container } from 'reactstrap'

import './Subnavigation.scss'

export default ({ children }) => (
    <Navbar color="dark" dark className="ao-subnavigation">
        <Container>
            <Nav className="mr-auto" navbar>
                { children }
            </Nav>
        </Container>
    </Navbar>
)
